export default {module:'Card/Form',view:'Element/Section',options:{xs:'auto'},children:[]}